var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"perzeption-footer"},[_c('h2',[_vm._v("PerZeption")]),_c('p',[_vm._v(" (888) 888-8888 | help@perzeption.vision ")])])}]

export { render, staticRenderFns }